import {
  SET_CENTRIFUGO_CONNECTED,
  SET_CENTRIFUGO_DISCONNECTED,
  SET_CENTRIFUGO_ERROR,
  SET_CENTRIFUGO_INITIAL_DATA,
} from '../../../../constants/centrifugo';

export const setCentrifugoConnected = (payload) => ({
  type: SET_CENTRIFUGO_CONNECTED,
  payload,
});

export const setCentrifugoDisconnected = () => ({
  type: SET_CENTRIFUGO_DISCONNECTED,
});

export const setCentrifugoError = () => ({
  type: SET_CENTRIFUGO_ERROR,
});

export const setCentrifugoInitialData = (payload) => ({
  type: SET_CENTRIFUGO_INITIAL_DATA,
  payload,
});
